import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import styles from './YandexSplitPeriods.module.css';

import type { FC, HTMLAttributes } from 'react';

const YandexSplitPeriods: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { className, ...restProps } = props;
  const { t } = useTranslation();

  const texts = [
    {
      text: t('ui.yandex-split.additional-period.70krub.text'),
      price: t('ui.yandex-split.additional-period.70krub.price'),
      note: t('ui.yandex-split.additional-period.note'),
    },
    {
      text: t('ui.yandex-split.additional-period.80krub.text'),
      price: t('ui.yandex-split.additional-period.80krub.price'),
      note: t('ui.yandex-split.additional-period.note'),
    },
  ];

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      {texts.map(({ text, note, price }) => (
        <div className={styles.block} key={text}>
          <span className={styles.text}>{text}</span>
          <div className={styles.priceContainer}>
            <span>{note}</span>
            <span className={styles.price}>{price}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default YandexSplitPeriods;
